export default __webpack_public_path__ + "static/media/department.94df86eb.png";